export default __webpack_public_path__ + "static/media/special.42dc5782.svg";